<template>
  <gwzLoginForm />
</template>

<script>
import gwzLoginForm from "@/components/gwzLoginForm.vue";

export default {
  components: {
    gwzLoginForm
  }
};
</script>

<style></style>
